import { render } from "./UserProfile.vue?vue&type=template&id=7c1b19b6&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=ts"
export * from "./UserProfile.vue?vue&type=script&lang=ts"

import "./UserProfile.vue?vue&type=style&index=0&id=7c1b19b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7c1b19b6"

export default script